
































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Accordion extends Vue {
  @Prop({ required: true }) private useAccordion!: string
  @Prop({ default: 900 }) private height!: number

  // hooks
  private mounted() {
    window.textAccordion()
  }

  private updated() {
    window.textAccordion()
  }

  /**
   * アコーディオンのクラスを取得
   */
  get accordionClass(): string {
    const classList = [
      'c-textAccordion__text--h' + this.height,
      'p-textAccordion__text--h' + this.height
    ]

    // アコーディオンの開閉を行わない場合
    if (!this.useAccordion) {
      classList.push('u-height--full')
    }

    return classList.join(' ')
  }
}
